import { createClient } from '@supabase/supabase-js';

// Initialize with placeholder values
let supabase = null;

// Function to initialize Supabase client with server config
const initializeSupabase = async () => {
  try {
    const response = await fetch('/api/config');
    const config = await response.json();
    supabase = createClient(config.supabaseUrl, config.supabaseAnonKey);
    return supabase;
  } catch (error) {
    console.error('Failed to initialize Supabase:', error);
    // Fallback to environment variables if available
    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
    const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
    if (supabaseUrl && supabaseAnonKey) {
      supabase = createClient(supabaseUrl, supabaseAnonKey);
    }
    return supabase;
  }
};

// Export function to get initialized Supabase client
export const getSupabase = async () => {
  if (!supabase) {
    await initializeSupabase();
  }
  return supabase;
};

// For backward compatibility, export supabase (will be null initially)
export { supabase };

// House table mapping
export const houseTableMapping = {
  'hesdin_hall': 'hesdin_hall_booking_calendar',
  'pigertons': 'pigertons_booking_calendar',
  'the_corn_crib': 'the_corn_crib_booking_calendar',
  'hayho_house': 'hayho_house_booking_calendar',
  'lady_avas_tower': 'lady_avas_tower_booking_calendar',
  'the_wealthy_merchant': 'the_wealthy_merchant_booking_calendar'
};

// House display names and capacities
export const houseInfo = {
  'hesdin_hall': { name: 'Hesdin Hall', capacity: 18 },
  'pigertons': { name: 'Pigertons', capacity: 12 },
  'the_corn_crib': { name: 'The Corn Crib', capacity: 20 },
  'hayho_house': { name: 'Hayho House', capacity: 14 },
  'lady_avas_tower': { name: 'Lady Ava\'s Tower', capacity: 24 },
  'the_wealthy_merchant': { name: 'The Wealthy Merchant', capacity: 4 }
};

// Stay type mapping
export const stayTypeMapping = {
  2: 'mid-week',
  3: 'weekend',
  4: 'mid-week',
  7: 'full-week'
};

export const stayTypeOptions = [
  { value: 2, label: '2 nights', type: 'mid-week' },
  { value: 3, label: '3 nights', type: 'weekend' },
  { value: 4, label: '4 nights', type: 'mid-week' },
  { value: 7, label: '7 nights', type: 'full-week' }
];
